import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1ac377e4&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac377e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac377e4')) {
      api.createRecord('1ac377e4', component.options)
    } else {
      api.reload('1ac377e4', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1ac377e4&scoped=true&", function () {
      api.rerender('1ac377e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OfT77Clry80d/JS/comp/SearchFilterTokens.vue"
export default component.exports